import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    const { page = 1, limit = 20, type, status } = payload || {}

    return buildApiUrl(ADMIN_ENDPOINTS.KYC_LIST, {
      queryParams: {
        page,
        limit,
        type,
        status
      }
    })
  },

  parse(raw = {}, payload = {}) {
    // MonRapidoo API retourne statusCode/message au lieu de success
    if (!raw?.statusCode || raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch KYC queue',
        data: null,
      }
    }

    const kycDocs = raw.data?.data || [] // Tableau dans data.data
    const pagination = raw.data || {}

    // Mapping pour correspondre au format attendu par le dashboard
    const formatted = kycDocs.map(doc => {
      const kycData = doc.data || {}
      const metadata = doc.metadata || {}
      const verification = doc.verification || {}

      return {
        id: doc.id,
        userId: doc.userId,
        userType: doc.userType, // 'rider' or 'restaurant'
        status: doc.status,
        uploadedAt: doc.submittedAt || doc.createdAt,
        createdAt: doc.createdAt,
        updatedAt: doc.updatedAt,

        // Nom utilisateur
        userName: kycData.personalInfo?.firstName && kycData.personalInfo?.lastName
          ? `${kycData.personalInfo.firstName} ${kycData.personalInfo.lastName}`.trim()
          : kycData.storeName || kycData.personalInfo?.companyName || 'Utilisateur',

        userEmail: kycData.personalInfo?.email || kycData.userEmail || kycData.email || '-',
        phoneNumber: kycData.personalInfo?.phone || kycData.phoneNumber || '-',
        address: kycData.personalInfo?.address || '-',
        city: kycData.personalInfo?.city || '-',
        country: kycData.personalInfo?.country || kycData.personalInfo?.countryCode || '-',

        // Statut
        kycStatus: doc.status,
        isValidated: doc.status === 'approved',
        isPending: doc.status === 'submitted',
        isRejected: doc.status === 'rejected',

        // Étapes
        requiredSteps: metadata.requiredSteps || [],
        completedSteps: metadata.completedSteps || [],
        nextAction: metadata.nextAction || '',

        // Vérification
        rejectionReason: verification.reason || '',
        rejectionNotes: verification.notes || '',
        reviewBy: verification.reviewedBy || '',
        reviewedAt: verification.reviewedAt || '',

        // Documents
        idType: kycData.identityDocument?.type,
        idNumber: kycData.identityDocument?.number,
        idFrontUrl: kycData.identityDocument?.frontPhotoUrl,
        idBackUrl: kycData.identityDocument?.backPhotoUrl,
        vehicleType: kycData.vehicleDocument?.type,
        licenseNumber: kycData.vehicleDocument?.number,
        vehiclePhotoUrl: kycData.vehicleDocument?.photoUrl,
        selfieUrl: kycData.selfieUrl || '',

        // Raw KYC data
        kycData: kycData,
      }
    })

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: pagination.total || formatted.length,
        result: formatted,
      },
    }
  },
}
